import { gqlProductFragment } from './shopify.fragments'
import { gql } from 'graphql-request'

export const shopifyProductsQuery = gql`
query {
  products(first: 50) {
    edges {
      node {
        ${gqlProductFragment}
      }
    }
  }
}
`

export const productByHandleQuery = gql`
query getProductByHandle($handle: String!) {
  productByHandle(handle: $handle) {
    ${gqlProductFragment}
  }
}
`

export const productByIdQuery = gql`
query getProductById($id: ID!) {
  product(id: $id) {
    ${gqlProductFragment}
  }
}
`

export const productRecommendationsQuery = gql`
query getProductRecommendations($productId: ID!) {
  productRecommendations(productId: $productId) {
    ${gqlProductFragment}
  }
}
`
